import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: 80,
    backgroundColor: theme.palette.primary.contrastText,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      paddingTop: 120
    }
  },
  noPermissionContainer: {
    height: 'calc(100vh - 500px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  noPermissionTitle: {
    fontSize: '1.375rem',
    fontWeight: 600,
    textAlign: 'center',
    margin: theme.spacing(6, 0)
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  bodyContainer: {
    marginTop: theme.spacing(5),
    backgroundColor: theme.palette.background.alt,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    paddingBottom: theme.spacing(6),

    [theme.breakpoints.up('lg')]: {
      padding: 0,
      borderRadius: 10,
      width: 1260,
      margin: '20px auto'
    }
  },
  mainContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between'
    }
  },
  title: {
    fontSize: '1.375rem',
    lineHeight: '27px',
    fontWeight: 600,
    textAlign: 'center',
    margin: theme.spacing(6, 0)
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(3),

    [theme.breakpoints.up('lg')]: {
      width: 430,
      gap: theme.spacing(2),
      margin: '20px auto',
      minHeight: 450
    }
  },
  input: {
    flexGrow: 1,
    '& fieldset': {
      backgroundColor: theme.palette.primary.contrastText,
      borderColor: theme.palette.primary.main,
      borderRadius: 3,
      minHeight: 45
    },

    '& label': {
      color: theme.palette.primary.main,
      fontWeight: 500,
      backgroundColor: theme.palette.primary.contrastText,
      paddingRight: theme.spacing()
    },
    '& input': {
      zIndex: 1,
      fontWeight: 500
    },
    '& > p': {
      color: theme.palette.secondary.contrastText
    },

    '&.multiline': {
      '& textarea': {
        zIndex: 1,
        fontWeight: 500,
        '&::-webkit-scrollbar': {
          width: 12,
          [theme.breakpoints.up('md')]: {
            width: 16
          }
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 5px grey',
          borderRadius: 10,
          backgroundColor: theme.utils.rgba(theme.palette.primary.main, 0.2)
        },
        /* Handle */
        '&::-webkit-scrollbar-thumb': {
          borderRadius: 10,
          background: theme.utils.rgba(theme.palette.primary.main, 0.45)
        }
      }
    }
  },
  option: {
    zIndex: '2 !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 500,
    color: theme.palette.secondary.contrastText,
    margin: theme.spacing(1, 0),
    marginRight: theme.spacing()
  },
  combo: {
    '& > div > label': {
      transform: 'translate(14px, 10px) scale(1)'
    },
    '& > div > div': {
      paddingBottom: `0 !important`,
      paddingTop: `0 !important`,
      paddingLeft: `${theme.spacing()} !important`,
      paddingRight: `${theme.spacing()} !important`
    },
    '& > div > div > div': {
      zIndex: 2
    },
    '& svg': {
      color: theme.palette.primary.main
    }
  },
  disciplinesContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    '& > div': {
      width: '100%'
    },

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row'
    }
  },
  tooltipTitle: {
    fontSize: '.75rem'
  },
  tooltip: {
    backgroundColor: theme.palette.tooltip.main,
    width: 180,
    maxWidth: 180,
    padding: `${theme.spacing(1, 2)} !important`
  },
  tooltipButton: {
    right: '3px !important',
    top: '2px !important'
  },
  tooltipLink: {
    color: theme.palette.primary.contrastText
  },
  tooltipArrow: {
    color: theme.palette.tooltip.main
  },
  infoButton: {
    alignSelf: 'flex-end',
    marginTop: -theme.spacing(2.5),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      alignSelf: 'flex-start',
      marginTop: theme.spacing(),
      marginBottom: 0,
      marginRight: -theme.spacing(5)
    }
  },
  errorMessage: {
    paddingLeft: theme.spacing(2)
  },
  select: {
    height: 40,
    width: '100%',
    backgroundColor: theme.palette.primary.contrastText,
    '& > div': {
      padding: theme.spacing(1, 1.75),
      paddingTop: theme.spacing(0.5),
      fontWeight: 500
    },
    '& input': {
      height: 3,
      color: theme.palette.primary.main
    },
    '& fieldset': {
      height: 45,
      borderColor: theme.palette.primary.main,
      borderRadius: 5
    },
    '& svg': {
      color: theme.palette.primary.main,
      height: 19
    }
  },
  labelSelect: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    paddingRight: theme.spacing(),
    backgroundColor: theme.palette.primary.contrastText,
    transform: 'translate(14px, 13px) scale(1)',

    '&.error': {
      color: '#f44336'
    }
  },
  numberLabel: {
    flexShrink: 0,
    fontSize: '.875rem'
  },
  otherContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    margin: theme.spacing(2, 0),
    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(1, 0),
      alignItems: 'center',
      flexDirection: 'row'
    }
  },
  numericField: {
    width: 80,
    maxWidth: 80
  },
  switchContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  },
  switchTitle: {
    fontSize: '.875rem'
  },
  createButton: {
    width: 250,
    height: 48,
    alignSelf: 'center',
    marginTop: theme.spacing(2),
    borderRadius: 8,
    '& span': {
      fontSize: '1.125rem',
      fontWeight: 500
    }
  },

  dateFormGroup: {
    marginTop: theme.spacing(2)
  },
  inputDatePicker: {
    margin: 0,
    minWidth: 120,

    '& input': {
      height: 4,
      backgroundColor: theme.palette.primary.contrastText,
      fontWeight: 500,
      fontSize: '.9rem'
    },
    '& fieldset': {
      height: 45,
      padding: theme.spacing(1.1, 1.8),
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: 3
    },
    '& svg': {
      color: theme.palette.primary.main
    },
    '& label': {
      color: theme.palette.primary.main,
      fontWeight: 500,
      transform: 'translate(14px, 11px) scale(1)',
      backgroundColor: theme.palette.primary.contrastText,
      paddingRight: theme.spacing(2.25)
    },
    '& > div > div': {
      marginLeft: 0
    },
    '& div > button': {
      width: 40,
      height: 40,
      borderRadius: 0,
      backgroundColor: theme.palette.primary.contrastText,
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.contrastText,
        color: theme.palette.primary.main
      }
    },
    '& > div': {
      paddingRight: 0,
      height: 40
    },
    [theme.breakpoints.up('sm')]: {
      width: 150
    }
  },
  pickers: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(2),
    gap: theme.spacing(3)
  },
  altErrorMessage: {
    fontSize: '.75rem'
  },
  datePickerFormGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5)
  },
  distanceAwardContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing()
  },
  typeFormGroup: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
      margin: 0
    }
  }
}))
